import { render, staticRenderFns } from "./PrimaryColor.vue?vue&type=template&id=456e2c36"
import script from "./PrimaryColor.vue?vue&type=script&lang=js"
export * from "./PrimaryColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports